import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Row, Col, Input, Table, Select, Button } from 'antd'
import _ from 'lodash'
import { popupStore } from 'store'
import { observable } from 'mobx'
import * as styles from './styles.scss'
@inject((store: any) => {
    const { popupStore, clinicServicesStore, clinicsStore } = store
    return { popupStore, clinicServicesStore, clinicsStore }
})
@observer
export default class ServiceFieldsNotRelatedClinicPopup extends Component<any, any> {
    state = {
        pagination: {
            current: 1,
            pageSize: 10,
            onChange: e => this.handlePageChange(e)
        }
    }
    componentDidMount() {}

    addRelationSeviceFieldToClinic = async id => {
        const { popupStore, clinicsStore, clinicServicesStore } = this.props
        try {
            let clinic_id = popupStore.info.clinic_id
            await clinicServicesStore.addServiceClinics(clinic_id, id)
            await clinicsStore.getClinic(clinic_id)
            const { clinic } = clinicsStore
            let clinic_serviceClinicsIds = _.map(clinic.serviceClinics, 'clinic_service_id')
            clinicServicesStore.setFilter('clinic_services_ids', clinic_serviceClinicsIds)
            clinicServicesStore.getFilteredClinicServicesList()
        } catch (e) {
            const { errors } = clinicServicesStore
            console.log(errors)
        }
    }
    deleteRelationSeviceFieldToClinic = async id => {
        const { popupStore, clinicsStore, clinicServicesStore } = this.props

        let clinic_id = popupStore.info.clinic_id
        await clinicServicesStore.deleteServiceClinics(clinic_id, id)
        await clinicsStore.getClinic(clinic_id)
        const { clinic } = clinicsStore
        let clinic_serviceClinicsIds = _.map(clinic.serviceClinics, 'clinic_service_id')
        clinicServicesStore.setFilter('clinic_services_ids', clinic_serviceClinicsIds)
        clinicServicesStore.getFilteredClinicServicesList()
    }
    handleFilterChange = (name, value) => {
        const { clinicServicesStore } = this.props

        clinicServicesStore.setFilter(name, value)
        clinicServicesStore.getFilteredClinicServicesList()
    }
    handleFilterChangeServiceName = (name, value) => {
        const { clinicServicesStore } = this.props

        clinicServicesStore.setFilter(name, value)

        clinicServicesStore.getFilteredClinicServicesList()
    }
    handlePageChange = page => {
        var pageObj = Object.assign({}, this.state)
        pageObj.pagination['current'] = page
        this.setState(pageObj)
    }
    closePopup = () => {
        const { popupStore, clinicsStore, clinicServicesStore } = this.props

        clinicServicesStore.resetFilters()
        let clinicsPage = popupStore.info.clinicsPage
        clinicsStore.getClinics(clinicsPage)
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, clinicServicesStore } = this.props

        const {
            loading,
            filters,
            filtered,
            getFilteredClinicServicesList,
            getClinicServicesList,
            resetFilters,
            errors
        } = clinicServicesStore
        const { serverErrors } = errors
        const clinic_serviceClinicsIds = filters.clinic_services_ids

        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם שירות',
                key: 'name',
                width: 500,
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'קישור',
                key: '',
                width: 100,
                align: 'right',
                render: (_, record) => {
                    if (clinic_serviceClinicsIds.includes(record.id)) {
                        return (
                            <a href="#" onClick={e => this.deleteRelationSeviceFieldToClinic(record.id)}>
                                <strong>הסר+</strong>
                            </a>
                        )
                    } else {
                        return (
                            <a href="#" onClick={e => this.addRelationSeviceFieldToClinic(record.id)}>
                                <strong>הוסף+</strong>
                            </a>
                        )
                    }
                }
            }
        ]
        return (
            <Modal
                title={'תחומי שירות'}
                visible={popupStore.popupType === 'serviceFieldListPopup'}
                cancelText="ביטול"
                width="900px"
                onOk={this.closePopup}
                onCancel={this.closePopup}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <Row>
                        <Col>{serverErrors ? <span className={styles.server_error}>{serverErrors}</span> : ''}</Col>
                    </Row>
                    <Row style={{ display: 'flex', alignItems: 'center' }}>
                        <Col xs={9}>
                            <label style={{ margin: '0' }}>
                                <strong>סינון על פי שיוך לתחומי שירות</strong>
                            </label>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="כל תחומי שירות"
                                onChange={e => this.handleFilterChange('service_clinic_related_type', e)}
                                value={filters.service_clinic_related_type}
                            >
                                <Select.Option value={null} key="ALL">
                                    כל תחומי שירות
                                </Select.Option>
                                <Select.Option value="NOT_RELATED" key="NOT_RELATED">
                                    תחומי שירות ללא שיוך למרפאה
                                </Select.Option>
                                <Select.Option value="RELATED" key="RELATED">
                                    תחומי שירות משוייכים למרפאה
                                </Select.Option>
                            </Select>
                        </Col>
                        <Col xs={6} style={{ padding: '0 0.5rem' }}>
                            <strong style={{ textDecoration: 'underline' }}>הזן שם שירות</strong>
                            <Input.Search
                                placeholder="הזן שם שירות"
                                value={filters.serviceName}
                                onChange={e => this.handleFilterChangeServiceName('serviceName', e.target.value)}
                            />
                        </Col>
                        <Col xs={3} style={{ marginTop: '0.6rem' }}>
                            <Button
                                style={{ margin: '0' }}
                                onClick={() => {
                                    resetFilters()
                                    getClinicServicesList()
                                    this.handlePageChange(1)
                                }}
                            >
                                איפוס חיפוש
                            </Button>
                        </Col>
                        <Col xs={3} style={{ marginTop: '0.6rem' }}>
                            <Button
                                type="primary"
                                style={{ marginTop: '0.5rem 0.5rem 0px' }}
                                onClick={() => {
                                    getFilteredClinicServicesList()
                                    this.handlePageChange(1)
                                }}
                            >
                                חפש תרופות
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} style={{ padding: '0 0.5rem' }}>
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                loading={loading}
                                columns={columns}
                                dataSource={filtered}
                                pagination={this.state.pagination}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        )
    }
}
